import { render, staticRenderFns } from "./BattleBracketsLevelChip.vue?vue&type=template&id=67b43dcc&scoped=true"
import script from "./BattleBracketsLevelChip.vue?vue&type=script&lang=js"
export * from "./BattleBracketsLevelChip.vue?vue&type=script&lang=js"
import style0 from "./BattleBracketsLevelChip.vue?vue&type=style&index=0&id=67b43dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b43dcc",
  null
  
)

export default component.exports